import classNames from 'classnames';
import Loading from '@/components/Loading/Loading';

// Holds the Deals carousel's rendered height (measured per breakpoint) while
// its chunk and the featured deals load, so the content below doesn't jump.
const DealsPlaceholder = ({
  isThankYouPage = false,
}: {
  isThankYouPage?: boolean;
}) => (
  <div
    className={classNames('flex items-center justify-center bg-white', {
      'min-h-[600px] md:min-h-[605px] lg:min-h-[381px]': !isThankYouPage,
      'min-h-[560px] xs:min-h-[569px] md:min-h-[581px] lg:min-h-[360px]':
        isThankYouPage,
    })}
  >
    <Loading />
  </div>
);

export default DealsPlaceholder;
